import React from 'react';
import { AdminToolGridSkeleton } from 'src/components/widgets/adminToolCard';

export default function ConsoleSkeleton() {
    return <AdminToolGridSkeleton />;
}
